const CDN_URL = 'https://cdn.best-start.org';

const AIRPLANE = `${CDN_URL}/assets/airplane.png`;

const BESTSTART_LOGO_WHITE = `${CDN_URL}/images/logos/bs-logo-white-500x172.png`;
const BESTSTART_LOGO_WHITE_SMALL = `${CDN_URL}/images/logos/bs-logo-white-250x86.png`;
const BOAT = `${CDN_URL}/assets/boat.png`;
const BOY = `${CDN_URL}/assets/boy.png`;
const BALLOON = `${CDN_URL}/assets/boy-balloon.png`;
const ROCKET = `${CDN_URL}/assets/boy-rocket.png`;
const BUTTON_BLUE = `${CDN_URL}/assets/button-blue.png`;
const BUTTON_GREEN = `${CDN_URL}/assets/button-green.png`;
const BUTTON_RED = `${CDN_URL}/assets/button-red.png`;
const CLOUD_1 = `${CDN_URL}/assets/cloud1.png`;
const CLOUD_2 = `${CDN_URL}/assets/cloud2.png`;
const DOODLE_BOAT = `${CDN_URL}/assets/doodle-boat.png`;
const DOODLE_PLANE = `${CDN_URL}/assets/doodle-plane.png`;
const DOODLE_SPACE = `${CDN_URL}/assets/doodle-space.png`;
const GIRL = `${CDN_URL}/assets/girl.png`;
const KID_1 = `${CDN_URL}/assets/kid1.png`;
const KID_2 = `${CDN_URL}/assets/kid2.png`;
const KID_3 = `${CDN_URL}/assets/kid3.png`;
const KID_4 = `${CDN_URL}/assets/kid4.png`;
const LIGHTBULB = `${CDN_URL}/assets/lightbulb.png`;
const TANIWHA = `${CDN_URL}/assets/taniwha.png`;
const TEACHER = `${CDN_URL}/assets/teacher.png`;
const SMALL_ICON = `${CDN_URL}/assets/small-icon.png`;

const CLOUD_1_WHITE = `${CDN_URL}/assets/cloud1-white.png`;
const CLOUD_2_WHITE = `${CDN_URL}/assets/cloud2-white.png`;
const TANIWHA_WHITE = `${CDN_URL}/assets/taniwha-white.png`;
const LIGHBULB_WHITE = `${CDN_URL}/assets/lightbulb-white.png`;
const AIRPLANE_WHITE = `${CDN_URL}/assets/airplane-white.png`;
const AIRPLANE_WHITE_2 = `${CDN_URL}/assets/airplane-white-2.png`;
const HEART_WHITE = `${CDN_URL}/assets/heart-white.png`;
const STAR_WHITE = `${CDN_URL}/assets/star-white.png`;
const BOAT_WHITE = `${CDN_URL}/assets/boat-white.png`;
const FLOWER_WHITE = `${CDN_URL}/assets/flower-white.png`;
const SPACESHIP_WHITE = `${CDN_URL}/assets/spaceship-white.png`;
const FLOWER_WHITE_2 = `${CDN_URL}/assets/flower-white-2.png`;
const SPACE_WHITE = `${CDN_URL}/assets/space-white.png`;
const BUBBLES_WHITE = `${CDN_URL}/assets/bubbles-white.png`;
const NOTES_WHITE = `${CDN_URL}/assets/notes-white.png`;
const LIGHTBULBS_WHITE = `${CDN_URL}/assets/lightbulbs-white.png`;


export {
    AIRPLANE,
    BOAT,
    BOY,
    BALLOON,
    ROCKET,
    BUTTON_BLUE,
    BUTTON_GREEN,
    BUTTON_RED,
    CLOUD_1,
    CLOUD_2,
    DOODLE_BOAT,
    DOODLE_PLANE,
    DOODLE_SPACE,
    GIRL,
    KID_1,
    KID_2,
    KID_3,
    KID_4,
    LIGHTBULB,
    TANIWHA,
    TEACHER,
    SMALL_ICON,
    BESTSTART_LOGO_WHITE,
    BESTSTART_LOGO_WHITE_SMALL,
    CLOUD_1_WHITE,
    CLOUD_2_WHITE,
    HEART_WHITE,
    STAR_WHITE,
    TANIWHA_WHITE,
    FLOWER_WHITE,
    FLOWER_WHITE_2,
    SPACESHIP_WHITE,
    SPACE_WHITE,
    BUBBLES_WHITE,
    NOTES_WHITE,
    LIGHTBULBS_WHITE,
    AIRPLANE_WHITE,
    AIRPLANE_WHITE_2,
    BOAT_WHITE,
    LIGHBULB_WHITE

}
